module.exports = __webpack_public_path__ + "img/the witch summit.8191fc5f.png";